import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import "./css/searchBar.css";

const useStyles = makeStyles((theme) => ({
  search: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    fontSize: "2em",
    "& .MuiInput-underline:after": {
      borderBottomColor: "#b0d1cc",
    },
    "& .MuiInputBase-root": {
      fontSize: "1em",
      textAlign: "center",
    },
  },
}));

function SearchBar(props) {
  const [results, setResults] = useState([]);
  const [inputString, setInputString] = useState("");
  const classes = useStyles();

  const searchChange = (event) => {
    const searchString = event.target.value;
    setInputString(searchString);
    if (searchString.length > 2) {
      fetch(`https://api.scryfall.com/cards/autocomplete?q=${searchString}`)
        .then((res) => res.json())
        .then((queryResponse) => {
          const responses = queryResponse.data.filter(
            (d) => d.indexOf("//") > -1
          );
          setResults(responses);
        })
        .catch((e) =>
          console.error(
            `Error fetching autocomplete scryfall data : ${e.stack}`
          )
        );
    }
  };

  const formSubmit = (event) => {
    event.preventDefault();
    if (results.length > 0) {
      props.selectCard(results[0]);
      setResults([]);
      setInputString("");
    }
  };

  const clickSubmit = (card) => {
    props.selectCard(card);
    setResults([]);
    setInputString("");
  };

  return (
    <div className={classes.search}>
      <form onSubmit={formSubmit}>
        <Input
          type="text"
          autoComplete="off"
          id="cardName"
          placeholder="Search for cards"
          onChange={searchChange}
          value={inputString}
          className="searchBar"
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </form>

      {results.map((res, i) => (
        <div key={i} className="option" onClick={() => clickSubmit(res)}>
          {res}
        </div>
      ))}
    </div>
  );
}

export default SearchBar;
